import { render, staticRenderFns } from "./HomeRankingCard.vue?vue&type=template&id=4299162b"
import script from "./HomeRankingCard.vue?vue&type=script&lang=js"
export * from "./HomeRankingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports